import React from "react";
import { useIntl } from "react-intl";

import { SelectComponent } from "@app/core/select";

import styles from "@app/styles/dashboard/filter-bar.module.scss";

interface IEventsFilterBarProps<TAction extends string> {
  actionFilter?: TAction;
  /** The actions to offer, in display order — usually `Object.values(SomeActionEnum)`. */
  actions: readonly TAction[];
  labelKeyByAction: Record<TAction, string>;
  /** Label for the "no filter" option, e.g. "Alle uitkomsten". */
  allLabelId: string;
  onActionChange: (action?: TAction) => void;
}

/** Filter on one action for a run's per-item rows. Shared by the sync and the descriptions. */
const EventsFilterBar = <TAction extends string>({
  actionFilter,
  actions,
  labelKeyByAction,
  allLabelId,
  onActionChange
}: IEventsFilterBarProps<TAction>): JSX.Element => {
  const intl = useIntl();

  const options = [
    { id: "", name: intl.formatMessage({ id: allLabelId }) },
    ...actions.map((action) => ({ id: action, name: intl.formatMessage({ id: labelKeyByAction[action] }) }))
  ];

  return (
    <div className={styles.filterBar}>
      <SelectComponent
        autoWidth
        value={actionFilter ?? ""}
        options={options}
        onChange={(e) => {
          const { value } = e.target;
          onActionChange(value ? (value as TAction) : undefined);
        }}
      />
    </div>
  );
};

export { EventsFilterBar };
